require('bootstrap-sass');
require('jquery-match-height');
require("jquery-mousewheel");
require('malihu-custom-scrollbar-plugin');
require('jquery-validation');
var timeago_vi = require("timeago.js/locales/vi.js");
var timeago = require("timeago.js");
timeago.register('vi', timeago_vi);
import Swiper from 'swiper/dist/js/swiper.js';

require("bxslider/dist/jquery.bxslider.min");
require("./comment");
import Cookies from 'js-cookie'


function checkViewMode() {
    var viewport = $('[name="viewport"]')[0];

    var viewMode = Cookies.get("view-mode", false);
    if (viewMode === "desktop") {
        viewport.setAttribute('content', 'width=1024');
    } else if (viewMode === "mobile") {
        viewport.setAttribute('content', 'width=device-width,initial-scale=1.0,maximum-scale=1.0,user-scalable=no');
    }
}


window.viewModePC = function () {
    Cookies.set('view-mode', "desktop");
    checkViewMode();
};

(function ($) {
    $(window).on("load", function () {
        checkViewMode();


        if ($(".mCustomScrollbar_Me").length) {
            $(".mCustomScrollbar_Me").mCustomScrollbar({
                autoDraggerLength: true,
                autoHideScrollbar: false,
            });
        }
    });
})(jQuery);
var windowsize = $(window).width();
$(document).ready(function () {
    new Swiper('.news_swiper__small', {
        slidesPerView: 1,
        //spaceBetween: 10,
        freeMode: true,
        navigation: {
            nextEl: '.news_swiper__small_next',
            prevEl: '.news_swiper__small_prev',
        },
        autoplay: {
            delay: 2500,
            disableOnInteraction: false,
        },
        breakpoints: {
            640: {
                slidesPerView: 1,
            },
            768: {
                slidesPerView: 1,
            },
            1024: {
                slidesPerView: 1,
            },
        }
    });
    var swiper = new Swiper('.news-swiper', {
        slidesPerView: 4,
        spaceBetween: 10,
        freeMode: true,
        navigation: {
            nextEl: '.news_swiper_next',
            prevEl: '.news_swiper_prev',
        },
        autoplay: {
            delay: 2500,
            disableOnInteraction: false,
        },
        breakpoints: {
            640: {
                slidesPerView: 2,
            },
            768: {
                slidesPerView: 4,
            },
            1024: {
                slidesPerView: 4,
            },
        }
    });


    if ($('.vedet-top-list').length) {


        let touchEng = windowsize < 630 ? 1 : 1;

        $('.vedet-top-list').bxSlider({
            minSlides: 1,
            maxSlides: 1,
            auto: true,
            pause: 12000,
            touchEnabled: touchEng,
            oneToOneTouch: false,
            controls: 0,
            pager: 1,
        });
    }

    if ($('.vedet-news-list-2-tin').length) {
        var windowsize = $(window).width();

        if (windowsize < 630) {
            $('.vedet-news-list-2-tin').bxSlider({
                minSlides: 1,
                maxSlides: 1,
                auto: false,
                pager: 0,
            });

        } else {
            $('.vedet-news-list-2-tin').bxSlider({
                slideWidth: 375,
                slideMargin: 10,
                minSlides: 1,
                maxSlides: 2,
                auto: false,
                pager: 1,
                controls: 0,
            });
        }
    }

    if ($('.vedet-news-list-3-tin').length) {
        var windowsize = $(window).width();

        if (windowsize < 630) {
            $('.vedet-news-list-3-tin').bxSlider({
                minSlides: 1,
                maxSlides: 1,
                auto: false,
                pager: 0,
            });

        } else {
            $('.vedet-news-list-3-tin').bxSlider({
                slideWidth: 250,
                slideMargin: 10,
                minSlides: 1,
                maxSlides: 3,
                auto: false,
                pager: 1,
                controls: 0,
            });
        }
    }

    if ($('#vedet-news-list').length) {
        var windowsize = $(window).width();

        if (windowsize < 630) {
            $('#vedet-news-list').bxSlider({
                minSlides: 1,
                maxSlides: 1,
                auto: false,
                pager: 0,
            });

        } else if (windowsize <= 1200) {
            $('#vedet-news-list').bxSlider({
                slideWidth: 220,
                slideMargin: 15,
                minSlides: 1,
                maxSlides: 4,
                auto: false,
                pager: 0,
            });

        } else {
            $('#vedet-news-list').bxSlider({
                slideWidth: 250,
                slideMargin: 15,
                minSlides: 1,
                maxSlides: 4,
                auto: false,
                pager: 0,
            });
        }

    }

});

$(document).on("click mouseover", ".wn__tab", function () {
    var tab = $(this).attr('data-tab');

    $('.tab__item').hide();

    $('.' + tab).show();
});


$(function () {
    if ($('.kvli,.ili,.album_col').length || $('.match-height').length) {
        $('.kvli,.ili,.album_col,.match-height').matchHeight({
            byRow: true,
            property: 'height',
            target: null,
            remove: false
        });
    }
    if ($('.need_time_ago').length) {
        timeago().render($('.need_time_ago'), 'vi');
    }
});
$(document).ready(function () {
    if ($('.list-partners-logo').length) {
        var maxSlides = 6;

        if (windowsize < 630) {
            maxSlides = 3;

        }

        $('.list-partners-logo').bxSlider({
            slideWidth: 175,
            slideMargin: 20,
            minSlides: maxSlides,
            maxSlides: maxSlides,
            auto: true,
            pager: 0,
        });
    }
});
$(document).ready(function () {
    if ($('#slider_related_article').length) {
        new Swiper("#slider_related_article", {
            pagination: ".swiper-pagination",
            slidesPerView: 3,
            paginationClickable: !0,
            preventClicks: !1,
            spaceBetween: 0,
            navigation: {
                nextEl: '.swiper-btn.next',
                prevEl: '.swiper-btn.prev',
            },
            autoplay: {
                delay: 3000,
            },
        });
    }
    if ($('#js_slider_photo').length) {
        new Swiper("#js_slider_photo", {
            pagination: ".swiper-pagination",
            initialSlide: 1,
            slidesPerView: 'auto',
            paginationClickable: !0,
            preventClicks: !1,
            centeredSlides: true,
            spaceBetween: 0,
            loop:true,

            navigation: {
                nextEl: '.swiper-button-next-photo',
                prevEl: '.swiper-button-prev-photo',
            },
            autoplay: {
                delay: 3000,
            },
        });
    }

    // if($('#slider_top_bar').length){
    //     new Swiper('#slider_top_bar', {
    //         pagination: ".swiper-pagination",
    //         paginationClickable: !0,
    //         preventClicks: !1,
    //         spaceBetween: 0,
    //         slidesPerView: 3,
    //         autoplay: {
    //             delay: 3000,
    //             disableOnInteraction: false
    //         },
    //         breakpoints: {
    //
    //             // when window width is <= 640px
    //             640: {
    //                 slidesPerView: 1
    //             }
    //         }
    //     });
    // }


    if ($('#frmContact').length) {
        $("#frmContact").validate({
            lang: 'vi',
            errorClass: 'text-danger',
            messages: {
                'Contact[subject]': {
                    required: 'Vui lòng nhập chủ đề liên hệ.'
                },
                'Contact[full_name]': {
                    required: 'Vui lòng nhập họ tên.'
                },
                'Contact[email]': {
                    required: 'Vui lòng nhập email liên hệ.',
                    email: "Vui lòng nhập đúng email."
                },
                'Contact[phone]': {
                    required: 'Vui lòng nhập số điện thoại đúng định đạng.'
                },

                'Contact[content]': {
                    required: 'Vui lòng nhập nội dung.',
                }
            },
            submitHandler: function (form) {
                $.ajax({
                    type: "post",
                    url: '/lien-he.html',
                    dataType: 'json',
                    data: $(form).serialize(),
                    beforeSend: function () {
                        $('input[type=text],textarea, button[type=submit]', $(form)).attr('disabled', true).css({'opacity': '0.5'});
                    },
                    success: function (res) {
                        $('input[type=text],select, button[type=submit]', $(form)).attr('disabled', false).css({'opacity': 1});
                        $('button[type=submit]').attr('disabled', false);
                        $(form)[0].reset();

                        if (res.status === 'success') {
                            swal({
                                "title": "Thành công",
                                "html": "<p style='color: #000;'>" + res.message + "</p>",
                                "type": "success"
                            });
                        } else {
                            swal({
                                "title": "Lỗi",
                                "html": res.message,
                                "type": "error",
                                "confirmButtonColor": "red"
                            });
                        }
                    }
                });
                return false;
            }

        });
    }

    $.ajaxSetup({
        headers: {
            'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
        }
    });
    $('#frmVote').submit(function (e) {
        e.preventDefault();
        var form = $('#frmVote');
        $.ajax({
            type: "post",
            url: '/vote-tham-do',
            dataType: 'json',
            data: $(form).serialize(),
            beforeSend: function () {
                $('input[type=text],textarea, button[type=submit]', $(form)).attr('disabled', true).css({'opacity': '0.5'});
            },
            success: function (res) {
                $('input[type=text],select, button[type=submit]', $(form)).attr('disabled', false).css({'opacity': 1});
                $('button[type=submit]').attr('disabled', false);


                if (res.status === 'success') {
                    swal({
                        // "title": "Thành công",
                        "html": "<p style='color: #000;'>" + res.message + "</p>",
                        "type": "success"
                    });
                } else {
                    swal({
                        "title": "Lỗi",
                        "html": res.message,
                        "type": "error",
                        "confirmButtonColor": "red"
                    });
                }
            }
        });

        return false;

    });


});


// Ajax Setup
$.ajaxPrefilter(function (options, originalOptions, jqXHR) {
    var token;
    if (!options.crossDomain) {
        token = $('meta[name="token"]').attr('content');
        if (token) {
            jqXHR.setRequestHeader('X-CSRF-Token', token);
        }
    }
    return jqXHR;
});


window.showFormSearch = function () {
    console.log('showFormSearch');
    $('.search_top_menu').toggle();
    $('.ndt-logo-mobile').toggle();
};

require('./scripts/go_top');



// WEBPACK FOOTER //
// ./resources/assets/js/blog.js